module.exports = __webpack_public_path__ + "img/125.d4527339.png";